import * as React from 'react';
import LegalPage from './sections/LegalPage';

export default function Privacy() {
  return <LegalPage title="Privacy Policy" fileUrl={`${process.env.PUBLIC_URL}/privacy.pdf`} />;
}
